import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardSharedTable from '@components/pages/Dashboard/Shared/DashboardSharedTable'
import SearchWithFilter from '@components/common/SearchWithFilter/SearchWithFilter.component'
import type { UseFinanceProductionPerProviderResult } from '@hooks/dashboard/useFinanceProductionPerProvider'
import { HYGIENE_PLACEHOLDER } from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { PRODUCTION_PER_PROVIDER_API_COLUMNS } from '../shared/financeTableColumns'

type ProductionPerProviderCardProps = {
  titleHref: string
  data: UseFinanceProductionPerProviderResult
  providerSearch: string
  onProviderSearchChange: (value: string) => void
  className?: string
  showFilter?: boolean
  searchClassName?: string
}

export function ProductionPerProviderCard({
  titleHref,
  data: api,
  providerSearch,
  onProviderSearchChange,
  className,
  showFilter = true,
  searchClassName,
}: ProductionPerProviderCardProps): React.ReactElement {
  const isEmpty = shouldShowDashboardSectionEmpty(api.loading, api.hasData)
  const pending = isDashboardSectionPending(api.loading, api.hasPayload)

  return (
    <DashboardSectionCard
      title="Production per provider"
      titleHref={titleHref}
      className={['dashboard-finance-production-provider-card', className]
        .filter(Boolean)
        .join(' ')}
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
      headerRight={
        isEmpty ? undefined : (
          <SearchWithFilter
            searchIcon="mgc mgc_search_2_line"
            filterIcon="mgc mgc_filter_2_line"
            placeholder="Search"
            searchQuery={providerSearch}
            onChange={(e) => onProviderSearchChange(e.target.value)}
            className={searchClassName}
            filters={{}}
            onFilterChange={() => {}}
            showFilter={showFilter}
          />
        )
      }
    >
      <div className="dashboard-finance-provider-table-wrap">
        <DashboardSharedTable
          loading={api.loading}
          showSearchFilter={false}
          columns={PRODUCTION_PER_PROVIDER_API_COLUMNS}
          data={api.filteredProviderData}
          showPagination={false}
          maxHeight="320px"
          footer={() => (
            <tr className="dashboard-finance-provider-table-total">
              <td colSpan={2} className="fw-semibold">
                Total
              </td>
              <td />
              <td className="fw-semibold">
                {api.loading ? HYGIENE_PLACEHOLDER : api.providerTotalFormatted}
              </td>
            </tr>
          )}
        />
      </div>
    </DashboardSectionCard>
  )
}
